"use client";

import { useSyncExternalStore } from "react";

const subscribe_noop = () => () => { };

// false on the server and during hydration, true right after (React re-renders once with the client snapshot).
// For values the server cannot know — the visitor's cart (AuthContext's is_auth/cart are empty in SSR), the current
// time — so the server HTML and the hydration pass render the same thing and the real value appears just after.
// Unlike a useState + useEffect pair this sets no state in an effect.
export default function useHydrated() {
	return useSyncExternalStore(subscribe_noop, () => true, () => false);
}
